import klydoApiClient, { KlydoType } from "../api/klydo";

// Exactly `SealedKlydo`, matching what the clock can actually be served.
//
// The legacy 'ApprovedKlydo' value does NOT count, even though it reads like a
// sealed klydo: the clock's sealed-only fetch queries the SealedKlydo mongoose
// discriminator, which filters on `type: 'SealedKlydo'` exactly, so such a
// document is never returned. Treating it as sealed queued a klydo the clock
// can never fetch — the silent stuck-pending retry this rule exists to stop.
export const isSealedKlydoType = (type: string): boolean =>
  type === KlydoType.Sealed;

/**
 * UI-side send validation (the enforcement deliberately lives in the UI, not
 * the API). Returns an error message, or null when the selection is valid:
 * every id must exist, and on a clock that does not allow drafts
 * (not dev/artist/rater) every klydo must be sealed — the same rule the
 * clock's own fetch applies, where a queued draft silently never delivers.
 */
export const validatePendingKlydoIds = async (
  ids: string[],
  draftsAllowed: boolean,
): Promise<string | null> => {
  const klydos = await klydoApiClient.getKlydosByIds(ids);
  const foundIds = new Set(klydos.map((k) => k.id));
  const missing = ids.filter((id) => !foundIds.has(id));
  if (missing.length) {
    return `Klydos not found: ${missing.join(", ")}`;
  }
  if (!draftsAllowed) {
    const notSealed = klydos
      .filter((k) => !isSealedKlydoType(k.type))
      .map((k) => k.id);
    if (notSealed.length) {
      return (
        "Only sealed klydos can be sent to a regular clock. " +
        `Not sealed: ${notSealed.join(", ")}`
      );
    }
  }
  return null;
};
